<template>
  <!-- A hazard's icon outside the map: the HiiKER sprite's warning triangle for
       its type, red when blocked, orange when passable (the orange one when the
       passability isn't known). A type this bundle doesn't know gets the
       sprite's generic warning icon. Same names as the map markers. -->
  <img
    class="hazard-type-icon"
    :src="src"
    :width="width"
    :height="height"
    :alt="alt"
    :data-icon="iconName"
    draggable="false"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { GENERIC_WARNING_ICON, hazardIconName } from '../../../utils/trailHazards/hazardSprite';
import { HAZARD_ICON_HEIGHT, HAZARD_ICON_WIDTH, hazardIconUrl } from '../../../utils/trailHazards/hazardIconAssets';

export default defineComponent({
  name: 'HazardTypeIcon',
  props: {
    /** hazard_type, either spelling (`tree_down` / `TREE_DOWN`). */
    hazardType: { type: String, default: null },
    /** Current passability, either spelling; null or unknown -> the neutral orange triangle. */
    passability: { type: String, default: null },
    /** Rendered width in CSS px; the height keeps the sprite's 90:82 triangle. */
    size: { type: Number, default: 32 },
    /** A sprite name to show as is (e.g. a route alert row's), instead of type + passability. */
    name: { type: String, default: null },
    /** Decorative by default: the type's name is always next to it. */
    alt: { type: String, default: '' },
  },
  computed: {
    iconName(): string {
      if (this.name && hazardIconUrl(this.name)) return this.name;
      return hazardIconName(this.hazardType, this.passability);
    },
    src(): string {
      return hazardIconUrl(this.iconName) ?? hazardIconUrl(GENERIC_WARNING_ICON) ?? '';
    },
    width(): number {
      return this.size;
    },
    height(): number {
      // The generic warning icon is round.
      if (this.iconName === GENERIC_WARNING_ICON) return this.size;
      return Math.round((this.size * HAZARD_ICON_HEIGHT) / HAZARD_ICON_WIDTH);
    },
  },
});
</script>

<style scoped>
.hazard-type-icon {
  flex: 0 0 auto;
  display: block;
  object-fit: contain;
  user-select: none;
}
</style>
